define.alias("shared/components/shared/publish/switcher/index", "calendar/components/shared/publish/switcher/index");